import { Badge } from '@/components/Badge/Badge';
import { Button } from '@/components/Button/Button';
import { formatDateTime, padIndex } from '@/lib/format';
import type { FollowMode } from '@/features/session/useFollowMode';
import styles from './FollowBanner.module.scss';

/**
 * States the sync clearly enough that an attendee always knows whether they are
 * on the presenter's topic or browsing on their own (US-4.3).
 */
export function FollowBanner({ follow }: { follow: FollowMode }) {
  if (!follow.available) return null;

  const position = follow.presenterPosition;
  const where = position
    ? `Module ${padIndex(position.module)} · Topic ${position.topic + 1}`
    : 'Waiting for the presenter';

  return (
    <div className={follow.following ? styles.banner : styles.paused}>
      <div className={styles.status}>
        <Badge tone={follow.following ? 'live' : 'warning'}>
          {follow.following ? 'Following presenter' : 'Browsing independently'}
        </Badge>
        <span className={styles.detail}>
          {where}
          {follow.lastUpdatedAt && ` · updated ${formatDateTime(follow.lastUpdatedAt)}`}
        </span>
      </div>

      {follow.error && <span className={styles.error}>{follow.error}</span>}

      {follow.following ? (
        <Button size="sm" variant="ghost" onClick={follow.pause}>
          Browse on my own
        </Button>
      ) : (
        <Button size="sm" onClick={follow.rejoin}>
          Rejoin presenter
        </Button>
      )}
    </div>
  );
}
